/**
 * @generated SignedSource<<65f78f13270c1152ede18d23d0658269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type MenuItemsListSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type MenuItemsListSortMutation$data = {
  readonly updateMenuItemPositions: boolean;
};
export type MenuItemsListSortMutation = {
  response: MenuItemsListSortMutation$data;
  variables: MenuItemsListSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateMenuItemPositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MenuItemsListSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MenuItemsListSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "56c399d50715de23bec98557d24ec52c",
    "id": null,
    "metadata": {},
    "name": "MenuItemsListSortMutation",
    "operationKind": "mutation",
    "text": "mutation MenuItemsListSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateMenuItemPositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "1a8d40abd37403aacaabc86beb992d7f";

export default node;
